// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableName__tableName___3ggEL{display:flex;align-items:center;padding:2px 0}.TableName__tableName___3ggEL.TableName__disabled___3yvld{opacity:0.4}.TableName__tableNameIcon___3LxlQ{width:32px;min-width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:500;background-color:#999;border-radius:100px;margin-right:16px;color:rgba(255,255,255,0.7);text-transform:uppercase}.TableName__tableNameText___7VfA4{font-size:14px;color:#333;display:flex;align-items:center}\n", ""]);
// Exports
exports.locals = {
	"tableName": "TableName__tableName___3ggEL",
	"disabled": "TableName__disabled___3yvld",
	"tableNameIcon": "TableName__tableNameIcon___3LxlQ",
	"tableNameText": "TableName__tableNameText___7VfA4"
};
module.exports = exports;
